module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_21.1f49407b.jpg";